import { createSlice } from "@reduxjs/toolkit";
import { changePasscode } from "../../apis/setting/changePasscode";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const changePasscodeSlice = createSlice({
    name: 'changePasscode',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(changePasscode.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(changePasscode.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(changePasscode.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default changePasscodeSlice.reducer